import requestTabTemplate from './requestTabTemplate';

export default requestTabTemplate(['requests'], ({ requests }) => requests.read);
